var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstablishmentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-location_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5312 10.1562C19.5312 8.29145 18.7905 6.50302 17.4718 5.18441C16.1532 3.86579 14.3648 3.125 12.5 3.125C10.6352 3.125 8.84677 3.86579 7.52816 5.18441C6.20954 6.50302 5.46875 8.29145 5.46875 10.1562C5.46875 13.0406 7.77656 16.8 12.5 21.3031C17.2234 16.8 19.5312 13.0406 19.5312 10.1562ZM12.5 23.4375C6.77031 18.2297 3.90625 13.8016 3.90625 10.1562C3.90625 7.87705 4.81166 5.69119 6.4233 4.07955C8.03494 2.46791 10.2208 1.5625 12.5 1.5625C14.7792 1.5625 16.9651 2.46791 18.5767 4.07955C20.1883 5.69119 21.0938 7.87705 21.0938 10.1562C21.0938 13.8016 18.2297 18.2297 12.5 23.4375Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 10.9375C12.9144 10.9375 13.3118 10.7729 13.6049 10.4799C13.8979 10.1868 14.0625 9.7894 14.0625 9.375C14.0625 8.9606 13.8979 8.56317 13.6049 8.27015C13.3118 7.97712 12.9144 7.8125 12.5 7.8125C12.0856 7.8125 11.6882 7.97712 11.3951 8.27015C11.1021 8.56317 10.9375 8.9606 10.9375 9.375C10.9375 9.7894 11.1021 10.1868 11.3951 10.4799C11.6882 10.7729 12.0856 10.9375 12.5 10.9375ZM12.5 12.5C11.6712 12.5 10.8763 12.1708 10.2903 11.5847C9.70424 10.9987 9.375 10.2038 9.375 9.375C9.375 8.5462 9.70424 7.75134 10.2903 7.16529C10.8763 6.57924 11.6712 6.25 12.5 6.25C13.3288 6.25 14.1237 6.57924 14.7097 7.16529C15.2958 7.75134 15.625 8.5462 15.625 9.375C15.625 10.2038 15.2958 10.9987 14.7097 11.5847C14.1237 12.1708 13.3288 12.5 12.5 12.5ZM20.9375 17.1875L23.4375 23.4375H16.4062V21.875H8.59375V23.4375H1.5625L4.0625 17.1875H20.9375ZM19.2547 17.1875H5.74531L3.87031 21.875H21.1297L19.2547 17.1875Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstablishmentLocation);
export default __webpack_public_path__ + "static/media/establishment_location.84bb29e9.svg";
export { ForwardRef as ReactComponent };